export const API_X_SOURCE = 'mcommerce';
export const API_X_SOURCE_WEB = 'portailvente_web';

export enum SAPI_X_VERSION {
    'V2' = '2',
    'V4' = '4',
}
